import BaseService from '../base.service';

export class RegisterService {
  static async registerApi(postData) {
    return BaseService.post('/web/register', postData);
  }
}
